export const menuItems = [
  {
    id: 1,
    htmlId: 'menu-why-work-with-us',
    displayName: 'Why Work With Us', // TODO: I18n this
    url: 'https://truelocalrealty.com/why-work-with-us/',
    ariaLabel: 'Why Work With Us',
    className: 'nav-menu-item',
    mobileClassName: '',
    children: [
      {
        id: 101,
        htmlId: 'menu-buyers',
        displayName: 'Buyers', // TODO: I18n this
        url: 'http://www.domain.com/link',
        ariaLabel: 'Buyers',
        className: 'nav-submenu-item listings-menu',
        mobileClassName: '',
        children: [],
        displayOnMobile: true,
        displayOnDesktop: true,
      },
      {
        id: 102,
        htmlId: 'menu-sellers',
        displayName: 'Sellers', // TODO: I18n this
        url: 'http://www.domain.com/link',
        ariaLabel: 'Sellers',
        className: 'nav-submenu-item listings-menu',
        mobileClassName: '',
        children: [],
        displayOnMobile: true,
        displayOnDesktop: true,
      },
    ],
    displayOnMobile: false,
    displayOnDesktop: true,
  },
  {
    id: 2,
    htmlId: 'menu-home',
    displayName: 'Home', // TODO: I18n this
    url: 'https://truelocalrealty.com/',
    ariaLabel: 'Home',
    className: '',
    mobileClassName: 'mobile-nav-menu-item',
    children: [],
    displayOnMobile: true,
    displayOnDesktop: false,
  },
  {
    id: 3,
    htmlId: 'menu-buyers',
    displayName: 'Buyers', // TODO: I18n this
    url: 'http://www.domain.com/link',
    ariaLabel: 'Buyers',
    className: '',
    mobileClassName: 'mobile-nav-menu-item',
    children: [],
    displayOnMobile: true,
    displayOnDesktop: false,
  },
  {
    id: 4,
    htmlId: 'menu-sellers',
    displayName: 'Sellers', // TODO: I18n this
    url: 'http://www.domain.com/link',
    ariaLabel: 'Sellers',
    className: '',
    mobileClassName: 'mobile-nav-menu-item',
    children: [],
    displayOnMobile: true,
    displayOnDesktop: false,
  },
  {
    id: 5,
    htmlId: 'menu-explore-areas',
    displayName: 'Explore Areas', // TODO: I18n this
    url: 'https://truelocalrealty.com/explore-areas/',
    ariaLabel: 'Explore Areas',
    className: 'nav-menu-item',
    mobileClassName: 'mobile-nav-menu-item',
    children: [],
    displayOnMobile: true,
    displayOnDesktop: true,
  },
  {
    id: 6,
    htmlId: 'menu-properties',
    displayName: 'Properties', // TODO: I18n this
    url: 'https://truelocalrealty.com/properties/',
    ariaLabel: 'Properties',
    className: '',
    mobileClassName: 'mobile-nav-menu-item',
    children: [],
    displayOnMobile: true,
    displayOnDesktop: false,
  },
  {
    id: 7,
    htmlId: 'menu-success-stories',
    displayName: 'Success Stories', // TODO: I18n this
    url: 'https://truelocalrealty.com/success-stories/',
    ariaLabel: 'Success Stories',
    className: 'nav-menu-item',
    mobileClassName: 'mobile-nav-menu-item',
    children: [],
    displayOnMobile: true,
    displayOnDesktop: true,
  },
  {
    id: 8,
    htmlId: 'menu-meet-the-team',
    displayName: 'Meet the Team', // TODO: I18n this
    url: 'https://truelocalrealty.com/about-us/',
    ariaLabel: 'Meet the Team',
    className: 'nav-menu-item',
    mobileClassName: 'mobile-nav-menu-item',
    children: [],
    displayOnMobile: true,
    displayOnDesktop: true,
  },
  {
    id: 9,
    htmlId: 'menu-advice',
    displayName: 'Advice', // TODO: I18n this
    url: 'https://truelocalrealty.com/blog/',
    ariaLabel: 'Advice',
    className: 'nav-menu-item',
    mobileClassName: 'mobile-nav-menu-item',
    children: [],
    displayOnMobile: true,
    displayOnDesktop: true,
  },
  {
    id: 10,
    htmlId: 'menu-contact-us',
    displayName: 'Contact Us', // TODO: I18n this
    url: 'https://truelocalrealty.com/contact-us/',
    ariaLabel: 'Contact Us',
    className: 'nav-menu-item',
    mobileClassName: 'mobile-nav-menu-item',
    children: [],
    displayOnMobile: true,
    displayOnDesktop: false,
  },
];
